module.exports = __webpack_public_path__ + "public-ui/img/agent.c91bdd4e.png";